// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__sb-7U","title":"editor_title__5GYjm","subtitle":"editor_subtitle__+cyhT"};